import React, { useState } from 'react';
import { styled, LazyImage, Swiper, Overlay } from '@teko/ui';
import { getTrackingData } from '@teko/tracking';
import { ImageGallery } from '../ImageGallery/ImageGallery.es.js';
import { FrameWrapper } from '../FrameWrapper/FrameWrapper.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const GalleryIndex = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
  padding: 6px 12px;
  border-radius: 17px;
  background-color: #f6f6f6;
  color: #848788;
  font-size: 14px;
  z-index: 1002;
`;
const Wrapper = styled.div`
  background-color: #fff;
  position: relative;
`;
const ImageWrapper = styled.div`
  border: 0;
`;
const StyledImage = styled(LazyImage)`
  position: initial;
  img {
    min-width: 100%;
    max-height: 100%;
  }
`;
const StyledTag = styled.div(({ color }) => `
  align-items: center;
  display: flex;
  position: absolute;
  z-index: 100;
  left: 16px;
  top: 3px;
  height: 16px;
  font-size: 10px;
  background-color: ${color};
  border-radius: 4px;
  color: #ffffff;
  padding: 0 8px;
  font-weight: 400;
`);
const ProductImagesMobile = ({
  images,
  galleryVisible = false,
  onOpen,
  onClose,
  frame,
  tag,
  sku
}) => {
  const [activeIndexSlide, setActiveIndexSlide] = useState(0);
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadValues({}, getTrackingData({
    isTrackContent: true,
    regionName: "imgProductDetail",
    contentName: "viewImage",
    target: "productImage",
    payload: JSON.stringify({
      sku,
      screenName: "productDetail",
      index: activeIndexSlide
    })
  })), tag && /* @__PURE__ */ React.createElement(StyledTag, {
    color: tag.color
  }, tag.value), !galleryVisible && /* @__PURE__ */ React.createElement(GalleryIndex, null, activeIndexSlide + 1, " / ", images.length), /* @__PURE__ */ React.createElement(Swiper, {
    className: "productDetailPreview",
    initialSlide: activeIndexSlide,
    onSlideChange: (swiper) => setActiveIndexSlide(swiper.activeIndex),
    slidesPerView: 1,
    slidesPerGroup: 1
  }, images.map((image) => /* @__PURE__ */ React.createElement(ImageWrapper, {
    key: image.src,
    className: "swiper-slide"
  }, frame && /* @__PURE__ */ React.createElement(FrameWrapper, {
    frame
  }), /* @__PURE__ */ React.createElement(StyledImage, {
    contain: true,
    height: frame ? void 0 : 280,
    imageWidth: 500,
    src: image.src,
    onClick: onOpen
  })))), /* @__PURE__ */ React.createElement(Overlay, {
    show: galleryVisible,
    onEscPressed: onClose
  }, /* @__PURE__ */ React.createElement(ImageGallery, {
    onClose,
    images: images.map((image) => ({
      imageUrl: image.src,
      caption: "",
      subCaption: "",
      thumbnailUrl: image.src
    })),
    frame
  })));
};

export { ProductImagesMobile };
